define(['jquery'], function ($) {

	var ResponsiveMainMenu = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.$linkLists = self.$ervBody.find('header .link-list');

		self.addEventListener = function () {
			$(document).click(function () {
				self.$linkLists.removeClass('is-expanded');
				$('body').removeClass('main-menu-expanded');
			});

			$(document).on('expandtrigger', function (e, param) {
				if (!param || !param.item) {
					return;
				}

				var $body = $('body');
				if (param.item.parent().find('ul li').length > 1) {
					$body.toggleClass('main-menu-expanded', !param.expanded);
				}
				else if (!param.expanded && $body.hasClass('main-menu-expanded')) {
					$body.removeClass('main-menu-expanded')
				}
			});
		}

		self.removeEventListener = function () {
			self.$linkLists.unbind();
			$(document).unbind('expandtrigger');
		}
	};

	ResponsiveMainMenu.prototype.initSmallerDevice = function () {
		var self = this;
		self.removeEventListener();
	}

	ResponsiveMainMenu.prototype.initLargeDevice = function () {
		var self = this;
		self.removeEventListener();
		self.addEventListener();
	}

	return ResponsiveMainMenu;
});